/* Bud Vase Editorial — theme.js */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const money = (cents) => {
    const fmt = window.MBV && window.MBV.moneyFormat ? window.MBV.moneyFormat : '${{amount}}';
    const val = (cents / 100).toFixed(2);
    const [i, d] = val.split('.');
    const grouped = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, `${grouped}.${d}`)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, grouped)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${i.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${d}`);
  };

  /* ---------- Overlay + drawers ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  const lock = (on) => document.body.classList.toggle('is-locked', on);
  function showOverlay() { if (!overlay) return; overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
  function hideOverlay() { if (!overlay) return; overlay.classList.remove('is-visible'); setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 350); }
  function open(el) {
    if (!el) return;
    if (openDrawer && openDrawer !== el) close(openDrawer, true);
    el.classList.add('is-open'); el.removeAttribute('aria-hidden');
    openDrawer = el; showOverlay(); lock(true);
    const f = el.querySelector('input:not([type=hidden]), button, a'); if (f) setTimeout(() => f.focus(), 350);
    document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id: el.id } }));
  }
  function close(el, keepOverlay) {
    el = el || openDrawer; if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (openDrawer === el) openDrawer = null;
    if (!keepOverlay) { hideOverlay(); lock(false); }
    $$('.header__search.is-open').forEach(s => s.classList.remove('is-open'));
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-drawer-open]');
    if (t) { e.preventDefault(); open($(t.dataset.drawerOpen)); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); close(); }
  });
  if (overlay) overlay.addEventListener('click', () => close());
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closeSearch(); } });

  /* Move the mobile menu drawer out of the sticky header's stacking context */
  const hoist = () => { const md = $('#MenuDrawer'); if (md && md.parentElement !== document.body) document.body.appendChild(md); };
  hoist(); document.addEventListener('shopify:section:load', hoist);

  /* ---------- Header: search, mobile submenus, scroll state ---------- */
  const header = $('[data-header]');
  const search = $('[data-search]');
  function closeSearch() { if (search && search.classList.contains('is-open')) { search.classList.remove('is-open'); search.setAttribute('aria-hidden', 'true'); hideOverlay(); lock(false); } }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      if (!search) return;
      const isOpen = search.classList.toggle('is-open');
      search.setAttribute('aria-hidden', String(!isOpen));
      if (isOpen) { showOverlay(); lock(true); setTimeout(() => $('input', search)?.focus(), 200); } else { hideOverlay(); lock(false); }
    }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    const sub = e.target.closest('[data-submenu-toggle]');
    if (sub) { e.preventDefault(); const li = sub.closest('li'); const exp = li.classList.toggle('is-open'); sub.setAttribute('aria-expanded', String(exp)); }
  });
  if (header) {
    let last = 0;
    const overlayHeader = header.hasAttribute('data-overlay-header');
    const onScroll = () => {
      const y = window.scrollY;
      const threshold = overlayHeader ? 80 : 400;
      const hide = y > threshold && y > last && !openDrawer;
      header.classList.toggle('is-hidden', hide);
      // overlay header: stay transparent while it slides away on the way down; turn solid only when it comes back
      if (!overlayHeader) header.classList.toggle('is-scrolled', y > 24);
      else if (y <= threshold) header.classList.remove('is-scrolled');
      else if (!hide) header.classList.add('is-scrolled');
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Cart ---------- */
  const cartDrawer = $('#CartDrawer');
  async function refreshCart(openAfter) {
    try {
      const res = await fetch(`${window.location.pathname === '/' ? '' : ''}/?sections=cart-drawer&t=${Date.now()}`);
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html && cartDrawer) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('#CartDrawer');
        if (fresh) {
          cartDrawer.querySelector('[data-cart-inner]').innerHTML = fresh.querySelector('[data-cart-inner]').innerHTML;
          const count = fresh.dataset.count;
          $$('[data-cart-count]').forEach(el => { el.textContent = count; el.classList.toggle('is-empty', count === '0'); });
        }
      }
      if (openAfter && cartDrawer && window.MBV && window.MBV.cartDrawer !== false) open(cartDrawer);
    } catch (err) { console.warn('cart refresh failed', err); }
  }
  async function addToCart(form, button) {
    const fd = new FormData(form);
    button && button.classList.add('is-loading');
    const label = button ? button.querySelector('[data-label]') : null;
    const orig = label ? label.textContent : '';
    if (label) label.textContent = (window.MBV && window.MBV.t.adding) || 'Adding…';
    try {
      const res = await fetch(`${window.MBV.routes.cart_add_url}.js`, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add');
      await refreshCart(true);
      if (label) { label.textContent = (window.MBV && window.MBV.t.added) || 'Added'; setTimeout(() => label.textContent = orig, 1600); }
      form.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: data }));
    } catch (err) {
      const msg = form.querySelector('[data-form-error]');
      if (msg) { msg.textContent = err.message; msg.hidden = false; }
      if (label) label.textContent = orig;
    } finally { button && button.classList.remove('is-loading'); }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('[data-product-form], [data-quick-add]')) {
      e.preventDefault();
      addToCart(form, form.querySelector('[type=submit]'));
    }
  });
  // line item changes inside drawer / cart page
  let changeTimer;
  async function changeLine(key, qty, root) {
    root && root.classList.add('is-busy');
    try {
      await fetch(`${window.MBV.routes.cart_change_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      if (root && root.hasAttribute('data-cart-page')) { window.location.reload(); return; }
      await refreshCart(false);
    } finally { root && root.classList.remove('is-busy'); }
  }
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0, rm.closest('[data-cart-root]')); return; }
    const qb = e.target.closest('[data-qty-change]');
    if (qb) {
      e.preventDefault();
      const wrap = qb.closest('.qty'); const input = wrap.querySelector('input');
      const min = parseInt(input.min || '1', 10);
      let v = parseInt(input.value || '1', 10) + parseInt(qb.dataset.qtyChange, 10);
      if (v < min) v = min;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) {
      clearTimeout(changeTimer);
      changeTimer = setTimeout(() => changeLine(input.dataset.lineQty, parseInt(input.value, 10) || 0, input.closest('[data-cart-root]')), 300);
    }
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(`${window.MBV.routes.cart_update_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* ---------- Product: variant picker + gallery ---------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = root.querySelector('[data-product-form]');
    const idInput = form && form.querySelector('[name=id]');
    const priceCur = root.querySelector('[data-price-current]');
    const priceCmp = root.querySelector('[data-price-compare]');
    const priceWrap = root.querySelector('[data-price]');
    const btn = form && form.querySelector('[type=submit]');
    const btnLabel = btn && btn.querySelector('[data-label]');
    const stock = root.querySelector('[data-stock]');
    const sku = root.querySelector('[data-sku]');
    const gallery = root.querySelector('[data-gallery]');
    const slides = gallery ? $$('[data-media-id]', gallery) : [];
    const thumbs = $$('[data-thumb]', root);

    function selected() {
      const groups = $$('[data-option-index]', root);
      if (!groups.length) return variants.find(v => idInput && String(v.id) === idInput.value) || variants[0];
      const opts = groups.map(group => {
        const checked = group.querySelector('input:checked') || group.querySelector('select');
        return checked ? checked.value : null;
      });
      return variants.find(v => v.options.every((o, i) => o === opts[i]));
    }
    function showMedia(id) {
      if (!gallery || !id) return;
      const target = slides.find(s => s.dataset.mediaId === String(id));
      if (!target) return;
      if (gallery.dataset.layout === 'carousel') {
        // jump straight to the picked image (no gliding past the ones in between) and fade it in
        gallery.dataset.jumping = '1';
        const left = gallery.scrollLeft + target.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
        gallery.scrollTo({ left, behavior: 'instant' });
        target.animate && target.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
        clearTimeout(gallery._jt); gallery._jt = setTimeout(() => { delete gallery.dataset.jumping; }, 200);
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
      $$('[data-gallery-dot]', root).forEach(d => d.classList.toggle('is-active', d.dataset.galleryDot === String(id)));
    }
    function update() {
      const v = selected();
      // mark unavailable combos
      $$('[data-option-index]', root).forEach((group, gi) => {
        $$('input', group).forEach(input => {
          const others = $$('[data-option-index]', root).map((g, i) => i === gi ? input.value : (g.querySelector('input:checked') || g.querySelector('select') || {}).value);
          const exists = variants.some(x => x.options.every((o, i) => o === others[i]) && x.available);
          input.closest('label').classList.toggle('is-unavailable', !exists);
        });
      });
      if (!v) {
        if (btn) { btn.disabled = true; btnLabel && (btnLabel.textContent = window.MBV.t.unavailable); }
        return;
      }
      if (idInput) idInput.value = v.id;
      const tradePct = priceWrap && priceWrap.dataset.trade ? parseFloat(priceWrap.dataset.trade) : 0;
      if (priceCur) priceCur.textContent = money(tradePct ? Math.round(v.price * (100 - tradePct) / 100) : v.price);
      $$('[data-price-retail]', root).forEach(el => { el.textContent = money(v.price); });
      if (priceCmp) { const on = v.compare_at_price && v.compare_at_price > v.price; priceCmp.hidden = !on; if (on) priceCmp.textContent = money(v.compare_at_price); priceWrap && priceWrap.classList.toggle('price--sale', !!on); }
      if (btn) { btn.disabled = !v.available; btnLabel && (btnLabel.textContent = v.available ? window.MBV.t.add_to_cart : window.MBV.t.sold_out); }
      if (sku) sku.textContent = v.sku || '';
      if (stock) { stock.hidden = !(v.available && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5); if (!stock.hidden) stock.textContent = window.MBV.t.low_stock.replace('__N__', v.inventory_quantity); }
      if (v.featured_media) showMedia(v.featured_media.id);
      if (root.hasAttribute('data-product-page')) { const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); }
    }
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) update(); });
    thumbs.forEach(t => t.addEventListener('click', (e) => { e.preventDefault(); showMedia(t.dataset.thumb); }));
    if (gallery && gallery.dataset.layout === 'carousel') {
      // Endless loop: clone the last slide before the first and the first after the last,
      // then silently jump back to the real slide when a clone settles in the main slot.
      const loop = slides.length > 1;
      if (loop) {
        const head = slides[slides.length - 1].cloneNode(true), tail = slides[0].cloneNode(true);
        [head, tail].forEach(c => { c.dataset.clone = '1'; c.setAttribute('aria-hidden', 'true'); });
        gallery.insertBefore(head, slides[0]); gallery.appendChild(tail);
        const toReal = (el) => gallery.scrollTo({ left: gallery.scrollLeft + el.getBoundingClientRect().left - gallery.getBoundingClientRect().left, behavior: 'instant' });
        requestAnimationFrame(() => toReal(slides[0]));
        let settle;
        const onSettle = () => {
          const all = [...gallery.children];
          const gl = gallery.getBoundingClientRect().left;
          const i = all.reduce((best, c, k) => Math.abs(c.getBoundingClientRect().left - gl) < Math.abs(all[best].getBoundingClientRect().left - gl) ? k : best, 0);
          if (all[i] === head) toReal(slides[slides.length - 1]);
          else if (all[i] === tail) toReal(slides[0]);
        };
        gallery.addEventListener('scroll', () => { clearTimeout(settle); settle = setTimeout(onSettle, 120); }, { passive: true });
      }
      const setActive = (id) => { thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.thumb === id)); $$('[data-gallery-dot]', root).forEach(d => d.classList.toggle('is-active', d.dataset.galleryDot === id)); };
      // Autoplay any video when it occupies the main slot; pause it when it leaves.
      const io = new IntersectionObserver((entries) => entries.forEach(en => {
        const v = en.target.querySelector('video');
        if (en.isIntersecting && en.intersectionRatio > .5) {
          if (!en.target.dataset.clone && !gallery.dataset.jumping) setActive(en.target.dataset.mediaId);
          if (v) { v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls'); const p = v.play(); if (p && p.catch) p.catch(() => {}); }
        } else if (v) { v.pause(); }
      }), { root: gallery, threshold: [0, .55, .95] });
      [...gallery.children].forEach(s => io.observe(s));
      $$('[data-gallery-dot]', root).forEach(d => d.addEventListener('click', () => showMedia(d.dataset.galleryDot)));
      $$('[data-gallery-prev],[data-gallery-next]', root).forEach(b => b.addEventListener('click', () => { gallery.scrollBy({ left: (b.hasAttribute('data-gallery-next') ? 1 : -1) * gallery.clientWidth, behavior: 'smooth' }); }));
    }
    update();
    // sticky mobile/desktop buy bar
    const bar = root.querySelector('[data-sticky-bar]');
    if (bar && btn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach(en => bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)), { threshold: 0 });
      io.observe(btn);
      bar.querySelector('[data-sticky-atc]').addEventListener('click', () => { btn.disabled ? btn.scrollIntoView({ behavior: 'smooth', block: 'center' }) : form.requestSubmit(); });
      const sp = bar.querySelector('[data-sticky-price]');
      root.addEventListener('change', () => { const v = selected(); if (!v || !sp) return; const tw = sp.querySelector('[data-trade]'); const cur = sp.querySelector('[data-price-current]'); if (cur) cur.textContent = money(tw ? Math.round(v.price * (100 - parseFloat(tw.dataset.trade)) / 100) : v.price); else sp.textContent = money(v.price); });
    }
  });

  /* ---------- Slideshow ---------- */
  $$('[data-slideshow]').forEach((show) => {
    const slides = $$('[data-slide]', show); if (slides.length < 2) return;
    const dots = $$('[data-slide-dot]', show);
    let i = 0, timer; const delay = parseInt(show.dataset.autoplay || '0', 10) * 1000;
    const go = (n) => { i = (n + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('is-active', k === i)); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); };
    const start = () => { if (delay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => go(i + 1), delay); };
    dots.forEach((d, k) => d.addEventListener('click', () => { clearInterval(timer); go(k); start(); }));
    $$('[data-slide-prev]', show).forEach(b => b.addEventListener('click', () => { clearInterval(timer); go(i - 1); start(); }));
    $$('[data-slide-next]', show).forEach(b => b.addEventListener('click', () => { clearInterval(timer); go(i + 1); start(); }));
    go(0); start();
  });

  /* ---------- Horizontal scrollers ---------- */
  $$('[data-scroller]').forEach((wrap) => {
    const track = $('[data-scroller-track]', wrap);
    $$('[data-scroller-prev],[data-scroller-next]', wrap).forEach(b => b.addEventListener('click', () => {
      const card = track.firstElementChild; const w = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * .8;
      track.scrollBy({ left: (b.hasAttribute('data-scroller-next') ? 1 : -1) * w * 2, behavior: 'smooth' });
    }));
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach((form) => {
    let t;
    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-price-input]')) { clearTimeout(t); t = setTimeout(() => form.requestSubmit(), 700); return; }
      form.requestSubmit();
    });
  });
  const sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', () => { const u = new URL(window.location); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); window.location = u; });

  /* ---------- Age gate: confirm once, remembered on this device ---------- */
  const gate = $('[data-age-gate]');
  if (gate) {
    let ok = false;
    try { ok = localStorage.getItem('mbv_age_ok') === '1'; } catch (e) {}
    if (!ok && document.cookie.indexOf('mbv_age_ok=1') > -1) ok = true;
    if (!ok) {
      gate.hidden = false; lock(true);
      requestAnimationFrame(() => requestAnimationFrame(() => gate.classList.add('is-open')));
      const yes = gate.querySelector('[data-age-gate-accept]');
      setTimeout(() => yes && yes.focus({ preventScroll: true }), 400);
      yes.addEventListener('click', () => {
        try { localStorage.setItem('mbv_age_ok', '1'); } catch (e) {}
        document.cookie = 'mbv_age_ok=1; max-age=31536000; path=/; SameSite=Lax';
        gate.classList.add('is-leaving');
        setTimeout(() => { gate.hidden = true; lock(false); const v = gate.querySelector('video'); if (v) v.pause(); }, 450);
      });
      gate.querySelector('[data-age-gate-decline]').addEventListener('click', () => {
        gate.querySelector('[data-age-gate-actions]').hidden = true;
        gate.querySelector('[data-age-gate-denied]').hidden = false;
      });
    }
  }

  /* ---------- Reveal on scroll ---------- */
  const rv = $$('[data-reveal]');
  if (rv.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(el => io.observe(el));
  } else rv.forEach(el => el.classList.add('is-in'));

  /* ---------- Stacked product gallery videos ---------- */
  $$('.product__gallery--stack video').forEach(v => {
    v.removeAttribute('controls'); v.muted = true; v.loop = true; v.playsInline = true;
    new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause(); }), { threshold: .5 }).observe(v);
  });

  /* ---------- Product card hover video ---------- */
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest('[data-product-card]'); if (!card || card.contains(e.relatedTarget)) return;
      const v = card.querySelector('[data-card-video]'); if (!v) return;
      if (!v.src) v.src = v.dataset.src;
      v.currentTime = 0; const p = v.play(); if (p && p.catch) p.catch(() => {});
    });
    document.addEventListener('mouseout', (e) => {
      const card = e.target.closest('[data-product-card]'); if (!card || card.contains(e.relatedTarget)) return;
      const v = card.querySelector('[data-card-video]'); if (v) v.pause();
    });
  }

  /* ---------- Misc ---------- */
  $$('[data-share]').forEach(b => b.addEventListener('click', async () => {
    const data = { title: document.title, url: window.location.href };
    if (navigator.share) { try { await navigator.share(data); } catch (e) {} }
    else { try { await navigator.clipboard.writeText(data.url); b.dataset.copied = '1'; b.querySelector('span').textContent = 'Link copied'; } catch (e) {} }
  }));
  // marquee duplication for seamless loop
  $$('[data-marquee]').forEach(m => { const inner = m.firstElementChild; if (inner) m.appendChild(inner.cloneNode(true)); });
})();

/* Auto-apply the wholesale code for approved trade buyers so checkout matches the prices shown */
(() => {
  const code = window.MBV && window.MBV.tradeCode; if (!code) return;
  try { if (sessionStorage.getItem('mbv-trade-code') === code) return; } catch (e) {}
  fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' }).then(() => { try { sessionStorage.setItem('mbv-trade-code', code); } catch (e) {} }).catch(() => {});
})();


/* ---------- Lace edge between every section ----------
   The lace is appended INSIDE the container whose colour it carries and is painted with that
   container's --section-bg variable, so it loads, fades and moves with the container. No own animation. */
(() => {
  const solid = (c) => c && c !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(c);
  const pageBg = getComputedStyle(document.body).backgroundColor;
  const ancestorBg = (el) => { for (let a = el; a && a !== document.documentElement; a = a.parentElement) { const c = getComputedStyle(a).backgroundColor; if (solid(c)) return c; } return pageBg; };
  const kids = (el) => [...el.children].filter(x => !x.classList.contains('doily-auto') && !/^(STYLE|SCRIPT|LINK|TEMPLATE)$/.test(x.tagName) && x.offsetHeight > 0);
  const hostOf = (sec, edge) => { const k = kids(sec); return edge === 'top' ? k[0] : k[k.length - 1]; };
  // colour at a section edge, used only to decide direction / skipping (painting always uses the variable)
  const edgeBg = (sec, edge) => {
    const full = sec.offsetWidth * 0.9;
    let el = hostOf(sec, edge), depth = 0;
    while (el && depth < 4 && el.offsetWidth >= full) {
      const c = getComputedStyle(el).backgroundColor;
      if (solid(c)) return c;
      const k = kids(el); el = edge === 'top' ? k[0] : k[k.length - 1]; depth++;
    }
    return ancestorBg(sec);
  };
  const lum = (c) => { const m = (c || '').match(/\d+(\.\d+)?/g); if (!m) return 1; const [r, g, b] = m.map(Number); return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255; };
  const startsWithMedia = (sec) => !!sec.querySelector(':scope > .hero, :scope > .banner, :scope > .image-banner, :scope > .wsg-hero');
  const pad = (sec, side) => { const el = hostOf(sec, side === 'top' ? 'top' : 'bottom'); if (!el) return; const prop = side === 'top' ? 'paddingTop' : 'paddingBottom'; el.style[prop] = 'calc(' + getComputedStyle(el)[prop] + ' + var(--lace-h))'; };
  const add = (host, cls) => { if (!host) return; const l = document.createElement('div'); l.className = 'doily-auto ' + cls; l.setAttribute('aria-hidden', 'true'); host.classList.add('lace-host'); host.appendChild(l); };

  const sections = [...document.querySelectorAll('main > .shopify-section, .shopify-section-group-footer-group')].filter(s => s.offsetHeight > 0);
  // stacking: whichever section carries the lace across an edge sits above its neighbour there
  const z = sections.map(() => 0); z[0] = 40;
  for (let i = 1; i < sections.length; i++) {
    const cur = sections[i], prev = sections[i - 1];
    const curMedia = startsWithMedia(cur), prevMedia = startsWithMedia(prev);
    z[i] = z[i - 1];
    if (curMedia && prevMedia) continue;
    const cPrev = prevMedia ? null : edgeBg(prev, 'bottom'), cCur = curMedia ? null : edgeBg(cur, 'top');
    if (!curMedia && !prevMedia && lum(cPrev) > 0.75 && lum(cCur) > 0.75) continue;       // light next to light: no lace
    const down = curMedia || (!prevMedia && lum(cPrev) < lum(cCur) - 0.004);               // always the darker colour
    if (down) { add(hostOf(prev, 'bottom'), 'doily-auto--down'); if (!curMedia) pad(cur, 'top'); z[i] = z[i - 1] - 1; }
    else      { add(hostOf(cur, 'top'), 'doily-auto--up');      if (!prevMedia) pad(prev, 'bottom'); z[i] = z[i - 1] + 1; }
  }
  sections.forEach((s, i) => { if (getComputedStyle(s).position === 'static') s.style.position = 'relative'; s.style.zIndex = Math.max(1, z[i]); });
  // banner photos inside a section (collection header, wholesale hero): lace in the colour of what sits below
  document.querySelectorAll('.collection__head--image').forEach((head) => add(head, 'doily-auto--inner'));
})();

/* ---------- Loading, intro and reveal motion ---------- */
(() => {
  const d = document.documentElement;
  if (!d.classList.contains('js-anim')) return;
  const loaded = () => d.classList.add('is-loaded');
  if (document.readyState !== 'loading') requestAnimationFrame(loaded); else document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(loaded));
  window.addEventListener('pageshow', (e) => { if (e.persisted) d.classList.remove('is-leaving'); d.classList.add('is-loaded'); });

  // Homepage: let the video breathe alone, then bring in the menu and hero copy
  if (d.classList.contains('intro')) {
    const vid = document.querySelector('.hero__video');
    let started = false;
    let finished = false;
    const finish = () => { if (finished) return; finished = true; d.classList.add('intro-play', 'intro-done'); setTimeout(() => d.classList.remove('intro', 'intro-play', 'intro-done'), 2300); };
    const go = () => { if (started) return; started = true; d.classList.add('intro-play'); setTimeout(finish, 1400); };
    if (vid) { if (!vid.paused && vid.currentTime > 0) go(); else { vid.addEventListener('playing', go, { once: true }); setTimeout(go, 1800); } }
    else go();
    // anyone who scrolls or tabs in skips the wait
    ['wheel', 'touchstart', 'keydown'].forEach(ev => window.addEventListener(ev, finish, { once: true, passive: true }));
  }

  // Scroll reveal for sections below the fold
  // Section backgrounds and their lace are never animated: only the content inside a section fades in.
  const isLace = (el) => el.classList.contains('doily-auto') || el.classList.contains('doily');
  const inner = (sec) => [...sec.children].filter(c => !isLace(c) && !/^(STYLE|SCRIPT|LINK|TEMPLATE)$/.test(c.tagName));
  const sectionLevel = [...document.querySelectorAll('main .shopify-section > section, main .shopify-section > div:not(.hero)')].filter(el => !isLace(el));
  const targets = [...new Set([...sectionLevel.flatMap(inner), ...document.querySelectorAll('.product-card, .card')])].filter(el => !isLace(el) && !el.querySelector('.doily-auto'));
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  targets.forEach((el, i) => {
    const wrapSec = el.closest('.shopify-section');
    if (el.closest('.hero') || el.querySelector('.hero') || el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
    if (wrapSec && wrapSec.previousElementSibling && wrapSec.previousElementSibling.querySelector(':scope > .hero')) return;
    el.setAttribute('data-reveal', '');
    if (el.matches('.product-card, .card')) el.style.setProperty('--rd', ((i % 4) * 0.08) + 's');
    io ? io.observe(el) : el.classList.add('is-in');
  });

  // Soft fade between pages on internal links
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || a.hasAttribute('download') || (url.pathname === location.pathname && url.hash) || /^(mailto|tel):/.test(a.href) || a.closest('[data-no-transition]')) return;
    if (/\/(cart|checkouts?|account\/logout)/.test(url.pathname) && a.closest('form')) return;
    e.preventDefault();
    d.classList.add('is-leaving');
    setTimeout(() => { location.href = a.href; }, 200);
  });
})();

/* Expose the announcement bar height so the homepage hero can sit behind it */
(() => {
  const a = document.querySelector('.announcement'); if (!a) return;
  const set = () => document.documentElement.style.setProperty('--ann-h', a.offsetHeight + 'px');
  set(); window.addEventListener('resize', set, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(set).observe(a);
})();

/* Homepage curtain: if the hero is taller than the screen, let it scroll to its bottom edge before it holds */
(() => {
  if (!document.body.classList.contains('template-index')) return;
  const h = document.querySelector('main > .shopify-section'); if (!h) return;
  const set = () => document.documentElement.style.setProperty('--hero-stick', Math.min(0, window.innerHeight - h.offsetHeight) + 'px');
  set(); window.addEventListener('resize', set, { passive: true });
})();
